module.exports = __webpack_public_path__ + "img/diagnostico.0bdfc301.png";